module.exports = __webpack_public_path__ + "static/media/metrics--dark.6f587554.png";